export const DEBOUNCE_INPUT = 500;
export const THROTTLE_REFRESH = 1000;

export const DOUBLE_CLICK_DELAY = 300;
